/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeightResponseDto } from './WeightResponseDto';
import {
    WeightResponseDtoFromJSON,
    WeightResponseDtoFromJSONTyped,
    WeightResponseDtoToJSON,
    WeightResponseDtoToJSONTyped,
} from './WeightResponseDto';
import type { HeightResponseDto } from './HeightResponseDto';
import {
    HeightResponseDtoFromJSON,
    HeightResponseDtoFromJSONTyped,
    HeightResponseDtoToJSON,
    HeightResponseDtoToJSONTyped,
} from './HeightResponseDto';
import type { AddressResponseDto } from './AddressResponseDto';
import {
    AddressResponseDtoFromJSON,
    AddressResponseDtoFromJSONTyped,
    AddressResponseDtoToJSON,
    AddressResponseDtoToJSONTyped,
} from './AddressResponseDto';

/**
 * 
 * @export
 * @interface GeneralInformationResponseDto
 */
export interface GeneralInformationResponseDto {
    /**
     * Patient unique identifier
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    patientId: string;
    /**
     * Patient email address
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    email: string;
    /**
     * Patient first name
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    firstName: string;
    /**
     * Patient middle name
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    middleName?: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    lastName: string;
    /**
     * Patient gender
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    gender: GeneralInformationResponseDtoGenderEnum;
    /**
     * Patient birth date
     * @type {Date}
     * @memberof GeneralInformationResponseDto
     */
    birthDate: Date;
    /**
     * Primary care provider phone number
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    primaryCarePhone?: string;
    /**
     * Patient phone number
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    phone?: string;
    /**
     * Emergency contact full name
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    emergencyContactName?: string;
    /**
     * Emergency contact phone number
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    emergencyContactPhone?: string;
    /**
     * Patient address
     * @type {AddressResponseDto}
     * @memberof GeneralInformationResponseDto
     */
    address?: AddressResponseDto;
    /**
     * Patient shipping address
     * @type {AddressResponseDto}
     * @memberof GeneralInformationResponseDto
     */
    shippingAddress?: AddressResponseDto;
    /**
     * Patient weight
     * @type {WeightResponseDto}
     * @memberof GeneralInformationResponseDto
     */
    weight?: WeightResponseDto;
    /**
     * Patient height
     * @type {HeightResponseDto}
     * @memberof GeneralInformationResponseDto
     */
    height?: HeightResponseDto;
    /**
     * Patient avatar URL
     * @type {string}
     * @memberof GeneralInformationResponseDto
     */
    photoUrl?: string;
    /**
     * Whether the patient account is restricted by a doctor
     * @type {boolean}
     * @memberof GeneralInformationResponseDto
     */
    isRestricted: boolean;
}


/**
 * @export
 */
export const GeneralInformationResponseDtoGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;
export type GeneralInformationResponseDtoGenderEnum = typeof GeneralInformationResponseDtoGenderEnum[keyof typeof GeneralInformationResponseDtoGenderEnum];


/**
 * Check if a given object implements the GeneralInformationResponseDto interface.
 */
export function instanceOfGeneralInformationResponseDto(value: object): value is GeneralInformationResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('isRestricted' in value) || value['isRestricted'] === undefined) return false;
    return true;
}

export function GeneralInformationResponseDtoFromJSON(json: any): GeneralInformationResponseDto {
    return GeneralInformationResponseDtoFromJSONTyped(json, false);
}

export function GeneralInformationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneralInformationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'email': json['email'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'gender': json['gender'],
        'birthDate': (new Date(json['birthDate'])),
        'primaryCarePhone': json['primaryCarePhone'] == null ? undefined : json['primaryCarePhone'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'emergencyContactName': json['emergencyContactName'] == null ? undefined : json['emergencyContactName'],
        'emergencyContactPhone': json['emergencyContactPhone'] == null ? undefined : json['emergencyContactPhone'],
        'address': json['address'] == null ? undefined : AddressResponseDtoFromJSON(json['address']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressResponseDtoFromJSON(json['shippingAddress']),
        'weight': json['weight'] == null ? undefined : WeightResponseDtoFromJSON(json['weight']),
        'height': json['height'] == null ? undefined : HeightResponseDtoFromJSON(json['height']),
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'isRestricted': json['isRestricted'],
    };
}

export function GeneralInformationResponseDtoToJSON(json: any): GeneralInformationResponseDto {
    return GeneralInformationResponseDtoToJSONTyped(json, false);
}

export function GeneralInformationResponseDtoToJSONTyped(value?: GeneralInformationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'email': value['email'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'gender': value['gender'],
        'birthDate': ((value['birthDate']).toISOString()),
        'primaryCarePhone': value['primaryCarePhone'],
        'phone': value['phone'],
        'emergencyContactName': value['emergencyContactName'],
        'emergencyContactPhone': value['emergencyContactPhone'],
        'address': AddressResponseDtoToJSON(value['address']),
        'shippingAddress': AddressResponseDtoToJSON(value['shippingAddress']),
        'weight': WeightResponseDtoToJSON(value['weight']),
        'height': HeightResponseDtoToJSON(value['height']),
        'photoUrl': value['photoUrl'],
        'isRestricted': value['isRestricted'],
    };
}

